<template>
  <div class="page-content">
    <div class="row">
      <div class="col-sm-6">
        <report-kudos-call />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const ReportKudosCall = defineAsyncComponent(() => import('./SendAnonymous/ReportKudosCall.vue') as any);

util.moveToTop();
</script>
